import { registerComponent, getComponentConfig } from "helpers";

//get product title
let productTitle = document.querySelector(".product-details__title");
let getProductTitle = '';
if(productTitle !=  null ) getProductTitle = productTitle.innerText + " - Bambi Baby";
//console.log("getProductTilte- ", getProductTitle);

registerComponent(
  "video-player",
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);

      this.bindEvents();
    }

    async fetchVimeoPreviewImageSrc() {
      const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.config.id}&format=json&width=1200`
      );
      const data = await response.json();
      return data.thumbnail_url;
    }

    bindEvents() {
      this.renderPreviewImage();

      if (this.config.previewOnly) {
        return;
      }

      this.addEventListener("click", this.renderVideo.bind(this));
      this.handleModalContext();
    }

    async renderPreviewImage() {
      if (this.config.type === "youtube") {
        this.previewImageSrc = `https://i.ytimg.com/vi/${this.config.id}/maxresdefault.jpg`;
      } else {
        this.previewImageSrc = await this.fetchVimeoPreviewImageSrc();
      }

      this.previewButton = this.querySelector("[data-preview]");
      this.previewImage = document.createElement("img");
      this.previewImage.setAttribute("src", this.previewImageSrc);
      this.previewImage.setAttribute("alt", getProductTitle);
      this.previewImage.setAttribute(
        "class",
        "video-player__preview-image fit-image"
      );
      this.previewImage.setAttribute("loading", "lazy");
      this.previewButton.append(this.previewImage);
    }

    renderVideo() {
      if (this.config.type === "youtube") {
        this.videoSrc = `https://www.youtube.com/embed/${this.config.id}`;
      } else {
        this.videoSrc = `https://player.vimeo.com/video/${this.config.id}`;
      }

      this.iframe = document.createElement("iframe");
      const width = this.previewButton.offsetWidth;
      const height = this.previewButton.offsetHeight;

      this.iframe.setAttribute("src", `${this.videoSrc}?autoplay=1`);
      this.iframe.setAttribute("frameborder", "0");
      this.iframe.setAttribute("allowfullscreen", "1");
      this.iframe.setAttribute("allow", "autoplay; encrypted-media");
      this.iframe.setAttribute("class", "video-player__iframe fit-image");
      this.iframe.setAttribute("width", width);
      this.iframe.setAttribute("height", height);
      this.iframe.setAttribute("frameborder", "0");

      this.setAttribute("ready", true);
      this.appendChild(this.iframe);
      this.classList.add("video-player--playing");
    }

    handleModalContext() {
      const modal = this.closest("[data-modal]");

      if (modal) {
        modal.addEventListener("modalOpen", this.renderVideo.bind(this));
        modal.addEventListener("modalClose", this.reset.bind(this));
      }
    }

    reset() {
      this.iframe.remove();
      this.classList.remove("video-player--playing");
    }
  }
);
